export default __webpack_public_path__ + "static/media/seyi-report_w640.8e1a6368.jpeg";